import MasterTable from "../../../../views/dashboard/widget/MasterTabel";
import {
  getExaminationSeriesList,
  addExaminationSeries,
  updateExaminationSeries,
  deleteExaminationSeries,
  updateExaminationSeriesStatus,
} from "../../../../services/Users-services.js";
import { useGlobalState } from "../../../../services/hostelConst.js";
import { getOrganizationLevel } from "../../../../services/OrganisationServices/organizationLevel";
import React, { useEffect, useState } from "react";
import AddGroupForm from "../../../FormComponents/AddGroups";
import { showErrorMessages } from "../../../../services/utilityFunctions";
import { useNavigate } from "react-router-dom";
import AddSeriesForm from "./addSeriesForm.js";
const ExaminationSeriesList = () => {
  const {
    _advanceFilterList,
    updateAdvanceFilterList,
    resetAdvanceFilterData,
    triggerChildSidebar,
  } = useGlobalState();
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
   
    resetAdvanceFilterData();
    updateAdvanceFilterList((prev) => {
      return {
        ...prev,
        date: true,
        status: true,
        region: true,
        site: true,
        department: true,
      };
    });
    setIsInitialized(true);

    return () => {};
  }, []);
  return !isInitialized ? (
    <div></div>
  ) : (
    <MasterTable
      getTableData={getExaminationSeriesList}
      updateStatus={updateExaminationSeriesStatus}
      deleteRow={deleteExaminationSeries}
      tab1={"Examination"}
      tab2={"Examination Series"}
      AddForm={AddSeriesForm}
      actions={{
        status: false,
        edit: true,
        delete: true,
      }}
    //   AddForm={AddExaminationTemplateForm}
    />
  );
};

export default ExaminationSeriesList;


